// @flow
import type { StoreResourceDef } from 'app/core/types'

export const jobCollectiveAgreementTitles: StoreResourceDef<> = {
  resourceType: 'jobCollectiveAgreementTitles',
}
